import { PkSpinner } from '@uefadigital/panenka-react';
import type { ComponentType } from 'react';
import { lazy, memo, Suspense } from 'react';

import { TicketingOptionsProvider } from './store';

import type { ModuleKey, TicketingOptions } from '@shared-types/ticketing.types';

const components: Record<ModuleKey, ComponentType> = {
  header: lazy(() => import(/* webpackPrefetch: true */ './components/Header')),
  yourteam: lazy(() => import(/* webpackPrefetch: true */ './components/YourTeam')),
  info: lazy(() => import(/* webpackPrefetch: true */ './components/TicketsInfo')),
  slot_include: lazy(() => import(/* webpackPrefetch: true */ './components/Slot')),
  keydates: lazy(() => import(/* webpackPrefetch: true */ './components/KeyDates')),
  ticketprices: lazy(() => import(/* webpackPrefetch: true */ './components/TicketPrices')),
  goodtoknow: lazy(() => import(/* webpackPrefetch: true */ './components/GoodToKnow')),
  faq: lazy(() => import(/* webpackPrefetch: true */ './components/Faq')),
  thirdparty: lazy(() => import(/* webpackPrefetch: true */ './components/ThirdPartyTickets')),
  langdisclaimer: lazy(() => import(/* webpackPrefetch: true */ './components/LanguageDisclaimer')),
  article: lazy(() => import(/* webpackPrefetch: true */ './components/Article')),
};

export const App = ({ options }: { options: TicketingOptions }) => {
  return (
    <TicketingOptionsProvider options={options}>
      <Suspense
        fallback={
          <div className='skl-ticketing-wrapper'>
            <div className='pk-mt--xl2'>
              <PkSpinner size='100' />
            </div>
          </div>
        }
      >
        {options.enabledModulesKey
          ?.filter((component) => components[component])
          .map((component) => {
            const Component = components[component];
            return <Component key={component} />;
          })}
      </Suspense>
    </TicketingOptionsProvider>
  );
};

export default memo(App);
